function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.49975,7 C12.49975,8.381 11.38075,9.5 9.99975,9.5 C8.61875,9.5 7.49975,8.381 7.49975,7 C7.49975,5.619 8.61875,4.5 9.99975,4.5 C11.38075,4.5 12.49975,5.619 12.49975,7 M9.99975,11 C7.79075,11 5.99975,9.209 5.99975,7 C5.99975,4.791 7.79075,3 9.99975,3 C12.20875,3 13.99975,4.791 13.99975,7 C13.99975,9.209 12.20875,11 9.99975,11 M19.39575,5.43 C17.57475,3.458 14.04975,0 9.99975,0 C5.94975,0 2.42475,3.458 0.60375,5.43 C-0.20125,6.303 -0.20125,7.697 0.60375,8.57 C2.42475,10.542 5.94975,14 9.99975,14 C14.04975,14 17.57475,10.542 19.39575,8.57 C20.20075,7.697 20.20075,6.303 19.39575,5.43",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -3 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/visible.19267230.svg";
export { SvgComponent as ReactComponent };